<template>
  <div class="recharge">
    <div class="horizontal-gradient border-radius">
      <div style="width: 100%; height: 184px; color: #fff">
        <van-sticky :offset-top="50">
          <div>{{ $t("account.balance") }}</div>
          <div style="padding: 10px; font-size: 28px">
            ${{ userInfo.showMoney }}
          </div>
          <div style="padding: 10px; font-size: 12px; color: #cbc6c6">
            ID:{{ userInfo.userId }}
          </div>
        </van-sticky>
      </div>
    </div>
    <div class="content-section">
      <van-form>
        <van-field
          v-model="bill.realname"
          name=""
          label=""
          placeholder="Please fill your real name"
          :rules="[{ required: true, message: 'Please fill your real name' }]"
        />
        <van-field
          v-model="bill.nums"
          type="number"
          name=""
          label=""
          placeholder="Offline recharge"
          :rules="[{ required: true, message: 'Please enter the amount!' }]"
        />
        <div style="margin: 16px">
          <van-button
            @click="billClick"
            round
            block
            type="info"
            native-type=""
            :disabled="rechargeButton"
            >{{ $t("button.recharge") }}</van-button
          >
        </div>
      </van-form>
    </div>

    <div>
      <van-tabbar
        safe-area-inset-bottom
        placeholder
        v-model="active"
        @change="onChange"
      >
        <van-tabbar-item to="/" icon="home-o" name="0">{{
          $t("tabbar.home")
        }}</van-tabbar-item>
        <van-tabbar-item to="/recharge" icon="cash-o" name="1">{{
          $t("tabbar.recharge")
        }}</van-tabbar-item>
        <van-tabbar-item :url="config.telegraph" icon="service-o" name="2">{{
          $t("tabbar.contact")
        }}</van-tabbar-item>
        <van-tabbar-item to="/account" icon="manager-o" name="3">{{
          $t("tabbar.account")
        }}</van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
import { rechargeBalance } from "@/common/api/api";

export default {
  name: "Recharge",
  components: {},
  data() {
    return {
      bill: {
        userId: "",
        realname: "",
        nums: "",
        uid: "",
      },
      active: 1,
      userInfo: {},
      url: "",
      config: {},
      ws: null,
      timer: "",
      rechargeButton: false,
    };
  },
  created() {
    this.userInfo = this.$store.getters.userInfo;
    this.config = this.$store.getters.config;
    // console.log(this.config)
  },
  methods: {
    onSubmit(values) {
      console.log("submit", values);
    },
    onChange(val) {
      this.active = val;
    },
    billClick() {
      this.rechargeButton = true;
      if (this.bill.nums < this.config.lowestRechargeCash) {
        this.$toast.fail({
          duration: 5000,
          message:
            "The recharge amount is too low, the minimum is " +
            this.config.lowestRechargeCash,
        });
        this.rechargeButton = false;
      } else {
        this.bill.userId = this.userInfo.userId;
        this.bill.uid =
          this.userInfo.username + "(" + this.userInfo.userId + ")";
        // console.log(this.bill);
        rechargeBalance(this.bill, "1").then((res) => {
          // window.open(this.config.telegraph, "_blank");
          this.bill.nums = "";
          this.bill.realname = "";
          this.$toast.success({
            duration: 5000,
            message: "Recharge successful",
          });
          this.rechargeButton = false;
        });
      }
    },
    initWebSocket() {
      if ("WebSocket" in window) {
        this.ws = new WebSocket(
          "ws://207.246.93.95:9327/websocket/" + this.userInfo.userId
        );

        this.ws.onopen = () => {
          console.log("ws connection open");
          this.isConnected = true;
          // this.sendMessageIfConnected();
        };

        this.ws.onclose = () => {
          console.log("ws connection closed");
          this.isConnected = false;
        };

        this.ws.onerror = (error) => {
          console.log("ws error");
          this.isConnected = false;
        };

        // this.ws.onmessage = (event) => {
        //   // const message = JSON.parse(event.data);
        //   // console.log(message);
        // }
      } else {
        // 如果不兼容则弹框，该浏览器不支持
        alert("This browser does not support");
      }
    },
  },
};
</script>

<style>
.horizontal-gradient {
  /* background: linear-gradient(to right, blue, pink); */
  background: #9d8040;
}

.border-radius {
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}

.box {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.content-section {
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 10px;
  margin: 0 10px 10px 10px;
}

/* .van-field__control {
  color: #323233;
} */
</style>
